<template>
  <div class="mx-4 border-b border-gray-300 last:border-none pb-2 flex flex-col">
    <!-- SECTION frequency/TOTAL -->
    <div class="flex items-baseline">
      <h3 class="font-semibold capitalize pb-1">{{ frequencyTitle }}</h3>
      <div class="flex-grow mx-1 border-b border-dashed border-gray-300"></div>
      <h3 class="font-semibold capitalize">{{ sectionTotal(section) }}</h3>
    </div>
    <div
      v-if="section.frequency === 'recurring'"
      class="text-gray-500 text-sm pb-2"
    >
      {{ section.bills_on_human_readable }}
    </div>
    <!-- SERVICE ITEMS -->
    <div
      v-for="service in serviceItems(section)"
      :key="service.id"
      class="py-1"
    >
      <div class="flex items-center text-sm">
        <ion-icon
          name="checkmark-outline"
          class="text-green-600 mr-1"
        ></ion-icon>
        {{ service.service }}
        <span
          class="text-gray-500 ml-1"
          v-if="isDeposit"
          >({{ section.items[0].deposit_data.deposit.name }})</span
        >
        <span
          class="text-gray-500 ml-1"
          v-if="isBalance"
          >({{ section.items[0].deposit_data.balance.name }})</span
        >
      </div>
    </div>
    <!-- ADD ONS TITLE -->
    <div
      class="bg-gray-100 rounded-lg my-3"
      v-if="hasAddOnServiceItems(section)"
    >
      <div class="border-b border-gray-300">
        <div class="uppercase px-3 py-2 text-sm">OPTIONAL ADD-ONS</div>
      </div>
      <!-- ADD ONS -->
      <div
        v-for="service in addOnServiceItems(section)"
        :key="service.id"
        class="grid grid-cols-2 gap-1 px-3 py-2 text-sm"
      >
        <div class="col-span-1 flex items-center">
          {{ service.service }}
          <span
            v-if="isDeposit"
            class="ml-1 text-gray-500"
            >({{ section.items[0].deposit_data.deposit.name }})</span
          >
          <span
            v-if="isBalance"
            class="ml-1 text-gray-500"
            >({{ section.items[0].deposit_data.balance.name }})</span
          >
        </div>

        <div class="col-span-1 flex items-center justify-end">
          {{ serviceTotal(service) }}{{ isHourlyFrequency(section) ? "/hr" : "" }}
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import currencyUtils from "../../../js/helpers/currencyUtils"

export default {
  name: "PortalBillingProposalPackageCardSection",
  data() {
    return {
      proposal: window.FinancialCents?.proposal,
    }
  },
  props: {
    section: {
      type: Object,
    },
    isDeposit: {
      type: Boolean,
      default: false,
    },
    isBalance: {
      type: Boolean,
      default: false,
    },
    selectedAddOns: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    frequencyTitle() {
      return this.isDepositOrBalanceItem ? "One-time" : this.section.frequency
    },

    isDepositOrBalanceItem() {
      return this.isDeposit || this.isBalance
    },
  },
  methods: {
    formatCurrency(value, currency) {
      return currencyUtils.convertAndFormatCurrency(value, currency)
    },

    serviceItems(section) {
      return section.items.filter((item) => !item.is_optional)
    },

    addOnServiceItems(section) {
      return section.items.filter((item) => item.is_optional)
    },

    hasAddOnServiceItems(section) {
      return section.items.filter((item) => item.is_optional).length > 0
    },

    isHourlyFrequency(section) {
      return section.frequency.toLowerCase() === "hourly"
    },

    sectionTotal(section) {
      if (this.isDepositOrBalanceItem) {
        if (section.items[0].is_optional) {
          return this.formatCurrency(0, this.proposal?.currency)
        }

        return this.isDeposit
          ? this.formatCurrency(section.items[0].deposit_data.deposit.amount, this.proposal?.currency)
          : this.formatCurrency(section.items[0].deposit_data.balance.amount, this.proposal?.currency)
      }

      return `${this.formatCurrency(section.total, this.proposal?.currency)}${this.isHourlyFrequency(section) ? "/hr" : ""}`
    },
    serviceTotal(service) {
      return this.isDepositOrBalanceItem
        ? this.isDeposit
          ? this.formatCurrency(service.deposit.amount, this.proposal?.currency)
          : this.formatCurrency(service.balance.amount, this.proposal?.currency)
        : `${this.formatCurrency(service.amount, this.proposal?.currency)}`
    },
  },
}
</script>
